export default class ShiftModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
